import { render, staticRenderFns } from "./Contracts.vue?vue&type=template&id=33fae55e"
import script from "./Contracts.vue?vue&type=script&lang=js"
export * from "./Contracts.vue?vue&type=script&lang=js"
import style0 from "./Contracts.vue?vue&type=style&index=0&id=33fae55e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports